import { getServices } from '~/db/services';

export const useGamingLoadFromNetwork = async (history: number = 0) => {
  const context = useContextStore();

  const { $db } = useNuxtApp();
  const { gamingsService } = getServices($db);

  const gaming = useGamingStore();

  const query = {
    history,
  };

  const _fetchData = async (url) => {
    const { result, error } = await useApiFetch(url, {
      method: 'GET',
      query,
    });
    if (error) {
      throw error;
    } else {
      return result;
    }
  };
  try {
    const loadedDataGaming = await _fetchData(`${URI.Gaming}`);
    if (query?.history === 0) {
      loadedDataGaming.streakHistory = toRaw(gaming.streakHistory);
    }
    await gamingsService.put({
      id: context.userId,
      data: loadedDataGaming,
    });

    gaming.forceUpdateRawValue(loadedDataGaming);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};
